<mat-form-field class="small" appearance="outline">
    <mat-label *ngIf="showLabel && (fieldLabel || placeholder)">{{ fieldLabel || placeholder }}</mat-label>
    <input #searchBox="matInput" matInput [formControl]="control" [type]="type" [placeholder]="placeholder" />
    <fa-icon matIconSuffix icon="search"></fa-icon>
</mat-form-field>
